import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 参考答案展示：把 [a|b] 等价写法模板还原为第一个备选（仅展示，不参与判分）
import { formatReferenceAnswer } from '@/utils/referenceAnswer'; // 六档评判策略码（与后端 ScoringService 白名单一致）

var DEFAULT_SCORING_STRATEGIES = ['exact', 'bilingual', 'structural', 'semantic_vector', 'intent', 'multi_dimension']; // 评判策略选项（含选择指引描述，语义与后端 ScoringOrchestrator / ScoringDefaults 权威口径一致）

var SCORING_STRATEGY_OPTIONS = [{
  value: 'exact',
  label: 'exact 精确匹配',
  desc: '客观题精确判定（单选/连线/排序/多选等）。学生答案与标准答案精确比对：命中判满分，未命中直接判 0 分，无部分分。适用于有唯一标准答案的客观题。'
}, {
  value: 'bilingual',
  label: 'bilingual 双语对照',
  desc: '翻译题评判（英译中/中译英）。参考答案含中文时按等价表述集合判对；参考答案纯英文时按关键词+语义加权评分，正确率≥60%判对。适用于翻译题。'
}, {
  value: 'structural',
  label: 'structural 结构约束',
  desc: '造句题评判。按关键词使用40%+语法正确性35%+语义合理性25%加权评分，正确率≥70%判对。适用于给定关键词造句题。'
}, {
  value: 'semantic_vector',
  label: 'semantic_vector 语义向量',
  desc: '情景对话评判。按语义相似度50%+要点覆盖率50%评分，正确率≥60%判对。适用于开放性情景对话类回答。'
}, {
  value: 'intent',
  label: 'intent 意图匹配',
  desc: '简单对话评判。按模板匹配60%+意图匹配40%评分，正确率≥60%判对。适用于问候、应答等简单对话。'
}, {
  value: 'multi_dimension',
  label: 'multi_dimension 多维度',
  desc: '写作等级制评判。按内容相关性25%+语言丰富度25%+准确性25%+结构完整性15%+创意10%五维评分，输出 A/B/C/D 等级（满分10分），不判定对错、不参与掌握度。适用于写作题。'
}];
export default {
  name: 'question-bank-edit',
  data: function data() {
    return {
      // 暴露给模板使用（Vue2 模板无法直接访问模块级 const，必须挂到组件实例，否则下拉渲染为“无数据”）
      SCORING_STRATEGY_OPTIONS: SCORING_STRATEGY_OPTIONS,
      isEdit: false,
      questionId: null,
      form: {
        title: '',
        question: '',
        content: '',
        pic: '',
        audio: '',
        choiceItem: '',
        correctAnswer: '',
        questionTypeId: 1,
        scoringStrategy: 'exact',
        skillDimension: '',
        bloomLevel: '',
        nodeId: '',
        explanation: '',
        status: 'draft',
        difficultyLevel: '★★',
        difficultyJson: ''
      },
      nodePathText: '',
      readonly: false,
      scoringStrategyTouched: false,
      rules: {
        title: [{
          required: true,
          message: '请输入题目标题',
          trigger: 'blur'
        }],
        question: [{
          required: true,
          message: '请输入题目内容',
          trigger: 'blur'
        }],
        correctAnswer: [{
          required: true,
          message: '请输入正确答案',
          trigger: 'blur'
        }],
        questionTypeId: [{
          required: true,
          message: '请选择题目类型',
          trigger: 'change'
        }],
        scoringStrategy: [{
          required: true,
          message: '请选择评判策略',
          trigger: 'change'
        }],
        skillDimension: [{
          required: true,
          message: '请选择技能维度',
          trigger: 'change'
        }],
        bloomLevel: [{
          required: true,
          message: '请选择布鲁姆层级',
          trigger: 'change'
        }],
        difficultyLevel: [{
          required: true,
          message: '请选择难度档位',
          trigger: 'change'
        }]
      },
      optionList: ['', '', '', ''],
      optionLetters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
    };
  },
  computed: {
    // 列表页「查看」带 readonly=1 进入，复用本页做只读查看，避免再建一套重复页面
    pageTitle: function pageTitle() {
      if (this.readonly) return '查看题目';
      return this.isEdit ? '编辑题目' : '新建题目';
    },
    hasOptions: function hasOptions() {
      return [1, 2, 6].includes(this.form.questionTypeId);
    },
    // 当前所选评判策略的说明文案（未选中/未知码时返回空串）
    currentStrategyDesc: function currentStrategyDesc() {
      var _this = this;

      var cur = SCORING_STRATEGY_OPTIONS.find(function (o) {
        return o.value === _this.form.scoringStrategy;
      });
      return cur ? cur.desc : '';
    },
    // 参考答案展示：仅当原始答案含 [a|b] 模板时展示还原后的只读预览
    showReferencePreview: function showReferencePreview() {
      return String(this.form.correctAnswer || '').indexOf('[') >= 0;
    },
    referenceAnswerPreview: function referenceAnswerPreview() {
      return formatReferenceAnswer(this.form.correctAnswer || '');
    }
  },
  watch: {
    'form.difficultyLevel': {
      handler: function handler() {
        this.buildDifficultyJson();
      }
    },
    // 题型/技能维度变化时，若用户未手动指定评判策略，则按规则带出默认策略（可改）
    'form.questionTypeId': function formQuestionTypeId() {
      if (!this.scoringStrategyTouched) {
        this.form.scoringStrategy = this.defaultScoringStrategy();
      }
    },
    'form.skillDimension': function formSkillDimension() {
      if (!this.scoringStrategyTouched) {
        this.form.scoringStrategy = this.defaultScoringStrategy();
      }
    }
  },
  mounted: function mounted() {
    this.readonly = this.$route.query.readonly === '1';
    var id = this.$route.params.id;

    if (id && id !== 'new') {
      this.isEdit = true;
      this.questionId = parseInt(id);
      this.loadQuestion();
    }
  },
  methods: {
    loadQuestion: function loadQuestion() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var d, dj;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.$api.getQuestion(_this2.questionId);

              case 3:
                d = _context.sent;

                if (!d) {
                  _context.next = 12;
                  break;
                }

                _this2.form = {
                  title: d.title || '',
                  question: d.question || '',
                  content: d.content || '',
                  pic: d.pic || '',
                  audio: d.audio || '',
                  choiceItem: d.choiceItem || '',
                  correctAnswer: d.correctAnswer || '',
                  questionTypeId: d.questionTypeId || 1,
                  scoringStrategy: d.scoringStrategy,
                  skillDimension: d.skillDimension || '',
                  bloomLevel: d.bloomLevel || '',
                  nodeId: d.nodeId || '',
                  explanation: d.explanation || '',
                  status: d.status || 'draft',
                  difficultyLevel: '★★',
                  difficultyJson: d.difficultyJson || ''
                };

                if (!_this2.form.scoringStrategy || !DEFAULT_SCORING_STRATEGIES.includes(_this2.form.scoringStrategy)) {
                  _this2.form.scoringStrategy = _this2.defaultScoringStrategy();
                }

                _this2.scoringStrategyTouched = !!(d.scoringStrategy && DEFAULT_SCORING_STRATEGIES.includes(d.scoringStrategy));

                if (d.choiceItem) {
                  _this2.optionList = d.choiceItem.split('|');
                }

                if (d.difficultyJson) {
                  try {
                    dj = JSON.parse(d.difficultyJson);
                    _this2.form.difficultyLevel = _this2.starsToLevel(dj);
                  } catch (e) {
                    /* ignore */
                  }
                }

                _context.next = 12;
                return _this2.loadNodeBindings();

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](0);

                _this2.$message.error('加载题目失败');

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 14]]);
      }))();
    },
    // 知识点绑定关系在 t_question_node，需单独取完整路径（题目详情接口不含 nodeId）
    loadNodeBindings: function loadNodeBindings() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var list, primary;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this3.$api.getQuestionNodeDetail(_this3.questionId);

              case 3:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 6;
                  break;
                }

                _context2.t0 = [];

              case 6:
                list = _context2.t0;
                primary = list.find(function (item) {
                  return item.bindType === 'primary';
                });

                if (primary) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return");

              case 10:
                _this3.form.nodeId = primary.nodeId || '';
                _this3.nodePathText = [primary.path, 'ID：' + (primary.nodeId || '')].filter(Boolean).join('  ');
                _context2.next = 16;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t1 = _context2["catch"](0);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 14]]);
      }))();
    },
    // 从 difficultyJson 解析出三星制档位
    starsToLevel: function starsToLevel(dj) {
      if (dj && dj.level) return dj.level;
      var s = dj ? Number(dj.stars != null ? dj.stars : dj.finalDifficulty) : NaN;

      if (!isNaN(s)) {
        if (s <= 1) return '★';
        if (s === 2) return '★★';
        return '★★★';
      }

      return '★★';
    },
    // 组装 difficultyJson，仅保留抽题引擎可识别的 level/stars 两级字段
    buildDifficultyJson: function buildDifficultyJson() {
      var stars = {
        '★': 1,
        '★★': 2,
        '★★★': 3
      }[this.form.difficultyLevel] || 2;
      this.form.difficultyJson = JSON.stringify({
        level: this.form.difficultyLevel,
        stars: stars
      });
    },
    // 按题型+技能维度带出默认评判策略（用户可改；编辑存量题时以后端值为准）
    defaultScoringStrategy: function defaultScoringStrategy() {
      var _this$form = this.form,
          questionTypeId = _this$form.questionTypeId,
          skillDimension = _this$form.skillDimension;
      if ([1, 2, 3, 6].includes(questionTypeId)) return 'exact';
      if (questionTypeId === 4 && skillDimension === 'writing') return 'multi_dimension';
      if (questionTypeId === 5 && skillDimension === 'writing') return 'multi_dimension';
      if (questionTypeId === 5) return 'bilingual';
      return 'exact';
    },
    // 用户手动选择过评判策略后，不再随题型/维度自动带出
    onScoringStrategyChange: function onScoringStrategyChange() {
      this.scoringStrategyTouched = true;
    },
    // 校验 typeId ↔ scoringStrategy 合法组合（P1 §4.3.1），非法返回错误提示文案，合法返回空串
    // 写作维度允许 exact（2026-10-26 用户裁定：管理端人工判断可用即放行）
    validateStrategyCombo: function validateStrategyCombo() {
      var _this$form2 = this.form,
          questionTypeId = _this$form2.questionTypeId,
          skillDimension = _this$form2.skillDimension,
          scoringStrategy = _this$form2.scoringStrategy;
      if (!scoringStrategy) return '';

      if ([1, 2, 3, 6].includes(questionTypeId) && scoringStrategy !== 'exact') {
        return '客观题（单选/连线/排序/多选）的评判策略仅支持 exact，请调整后再保存';
      }

      if (scoringStrategy === 'multi_dimension' && skillDimension !== 'writing') {
        return 'multi_dimension 评判策略仅适用于写作维度题目，请调整后再保存';
      }

      return '';
    },
    handleSave: function handleSave() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var comboError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this4.readonly) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", false);

              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return _this4.$refs.form.validate();

              case 5:
                _context3.next = 10;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](2);
                return _context3.abrupt("return", false);

              case 10:
                if (_this4.hasOptions) {
                  _this4.form.choiceItem = _this4.optionList.filter(function (o) {
                    return o;
                  }).join('|');
                } // 评判策略与题型/维度需为合法组合，非法组合直接拦截并给出明确提示（源头杜绝路由冲突）


                comboError = _this4.validateStrategyCombo();

                if (!comboError) {
                  _context3.next = 15;
                  break;
                }

                _this4.$message.error(comboError);

                return _context3.abrupt("return", false);

              case 15:
                _this4.buildDifficultyJson();

                _context3.prev = 16;

                if (!_this4.isEdit) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 20;
                return _this4.$api.updateQuestion(_this4.questionId, _this4.form);

              case 20:
                _this4.$message.success('更新成功');

                _context3.next = 26;
                break;

              case 23:
                _context3.next = 25;
                return _this4.$api.createQuestion(_this4.form);

              case 25:
                _this4.$message.success('创建成功');

              case 26:
                _this4.$router.push({
                  name: 'question-bank-list'
                });

                _context3.next = 32;
                break;

              case 29:
                _context3.prev = 29;
                _context3.t1 = _context3["catch"](16);

                _this4.$message.error('保存失败');

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 7], [16, 29]]);
      }))();
    },
    handleCancel: function handleCancel() {
      this.$router.push({
        name: 'question-bank-list'
      });
    },
    addOption: function addOption() {
      this.optionList.push('');
    },
    removeOption: function removeOption(index) {
      this.optionList.splice(index, 1);
    },
    // 需求：题库管理-音频试听。点击播放按钮播放当前音频URL，再次点击暂停
    previewAudio: function previewAudio() {
      var _this5 = this;

      var player = this.$refs.audioPlayer;
      if (!player) return;

      if (player.paused) {
        player.play().catch(function () {
          _this5.$message.error('音频播放失败，请检查URL是否有效');
        });
      } else {
        player.pause();
      }
    },
    onAudioError: function onAudioError() {
      this.$message.error('音频加载失败，请检查URL是否有效');
    },
    // 需求：题库管理-媒体上传与预览。图片/音频经后端既有 /api/audio/upload 上传腾讯云COS，返回URL回填表单
    // cosKey 对齐 TXCOSClient 既有目录约定：图片 images/question/，音频 audio/question/
    buildMediaCosKey: function buildMediaCosKey(folder, file) {
      var ext = ((file.name || '').split('.').pop() || 'bin').toLowerCase();
      var rand = Math.random().toString(36).substring(2, 8);
      return folder + '/question/q_' + Date.now() + '_' + rand + '.' + ext;
    },
    beforePicUpload: function beforePicUpload(file) {
      var okTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

      if (!okTypes.includes(file.type)) {
        this.$message.error('仅支持 jpg/png/gif/webp 格式图片');
        return false;
      }

      if (file.size > 5 * 1024 * 1024) {
        this.$message.error('图片大小不能超过 5MB');
        return false;
      }

      this.uploadMedia(file, this.buildMediaCosKey('images', file), '图片');
      return false; // 阻止 el-upload 默认提交行为，改走自定义上传
    },
    beforeAudioUpload: function beforeAudioUpload(file) {
      var okTypes = ['audio/mpeg', 'audio/mp3', 'audio/wav', 'audio/x-m4a', 'audio/mp4', 'audio/ogg'];

      if (!okTypes.includes(file.type) && !/\.(mp3|wav|m4a|ogg)$/i.test(file.name || '')) {
        this.$message.error('仅支持 mp3/wav/m4a/ogg 格式音频');
        return false;
      }

      if (file.size > 20 * 1024 * 1024) {
        this.$message.error('音频大小不能超过 20MB');
        return false;
      }

      this.uploadMedia(file, this.buildMediaCosKey('audio', file), '音频');
      return false; // 阻止 el-upload 默认提交行为，改走自定义上传
    },
    uploadMedia: function uploadMedia(file, cosKey, label) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var d;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this6.$message.info('正在上传' + label + '...');

                _context4.next = 4;
                return _this6.$api.uploadQuestionMedia(file, cosKey);

              case 4:
                d = _context4.sent;

                if (d && d.success && d.url) {
                  if (label === '图片') {
                    _this6.form.pic = d.url;
                  } else {
                    _this6.form.audio = d.url;
                  }

                  _this6.$message.success(label + '上传成功');
                } else {
                  _this6.$message.error(label + '上传失败' + (d && d.error ? '：' + d.error : ''));
                }

                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                _this6.$message.error(label + '上传失败');

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 8]]);
      }))();
    },
    // 移除图片：仅清空表单URL（不删除COS文件，保留恢复可能）
    handleRemovePic: function handleRemovePic() {
      this.form.pic = '';
    }
  }
};